import type { ShipmentType, ShipmentTypeDescription } from './types';

export const SHIPMENT_TYPE_DESCRIPTIONS: Record<ShipmentType, ShipmentTypeDescription> = {
  I: 'Inbound',
  N: 'Intercompany',
  O: 'Outbound',
  R: 'Return',
  '3': 'Third Party',
} as const;

export const PRINTED_BOL_FLAG_TYPES = { NO: 'No', YES: 'yes', Y: 'yes' } as const;
export const SHIPMENT_LOCATION_STOP = { SHIPPER: '1', CONSIGNEE: '2' } as const;

export const SHIPMENT_STATUS = {
  Approved: 'Approved',
  AutoRated: 'Auto-Rated',
  AutoRoute: 'Auto-Route',
  AutoTendered: 'Auto-Tendered',
  BOL: 'BOL',
  Cancelled: 'Cancelled',
  Closed: 'Closed',
  Confirmed: 'Confirmed',
  Hold: 'Hold',
  InTransit: 'In-Transit',
  Invoiced: 'Invoiced',
  New: 'New',
  Partial: 'Partial',
  Planning: 'Planning',
  Quote: 'QUOTE',
  RateError: 'Rate Error',
  Rated: 'Rated',
  Routed: 'Routed',
  SpotBid: 'Spot Bid',
  SpotBidEnd: 'SpotBidEnd',
  Tender: 'Tender',
  Unapproved: 'Unapproved',
} as const;
